module.exports = __webpack_public_path__ + "static/media/edit.dcc18974.svg";